export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5109.7d8fdc0b.jpg";